import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import menuConfig from "constants/menuConfig";
import { useHeader } from "providers/AreasProvider";
import { makeStyles, AppBar, Toolbar, Hidden, Typography, IconButton } from "@material-ui/core";
import MoreVert from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/icons/Menu";
import HelpButton from "features/helpButton/components/HelpButton";
import headerStyle from "assets/jss/components/headerStyle";
import UserMenu from "features/userMenu/components/UserMenu";
import LanguageSelector from "components/menu/LanguageSelector";
import DealerSelector from "components/menu/DealerSelector";

const useStyles = makeStyles(headerStyle);

const makeBrand = (pathname) => {
  var name;
  menuConfig.map((menu) => {
    if (menu.path === pathname) {
      name = menu.name;
    }
    return null;
  });

  if (pathname === "/user") {
    name = "User";
  }

  if (pathname === "/my-profile") {
    name = "MyProfile";
  }

  return name || "";
};

function Header({ miniActive, sidebarMinimize, handleDrawerToggle }) {
  const { t } = useTranslation();
  const location = useLocation();
  const [header] = useHeader();
  const classes = useStyles();
  const pathName = makeBrand(location.pathname);
  const headerRef = useRef();

  return (
    <AppBar position="sticky" className={classes.appBar + " " + classes.theme}>
      <Toolbar className={classes.container}>
        <Hidden smDown>
          <div className={classes.sidebarMinimize}>
            {miniActive ? (
              <IconButton color="default" onClick={sidebarMinimize}>
                <Menu fontSize="small" />
              </IconButton>
            ) : (
              <IconButton color="default" onClick={sidebarMinimize}>
                <MoreVert fontSize="small" />
              </IconButton>
            )}
          </div>
          {header || (
            <Typography variant="subtitle1" className={classes.title}>
              {pathName && t("NavBar." + pathName)}
            </Typography>
          )}
        </Hidden>
        <Hidden mdUp>
          {header || (
            <Typography variant="subtitle1" className={classes.titleMobile}>
              {pathName && t("NavBar." + pathName)}
            </Typography>
          )}
        </Hidden>
        <div className={classes.w100} ref={headerRef}></div>
        <DealerSelector />
        <HelpButton />
        <Hidden smDown>
          <LanguageSelector miniActive={false} className={classes.headerLanguageSelector} />
        </Hidden>
        <Hidden smDown>
          <UserMenu />
        </Hidden>
        <Hidden mdUp>
          <div className={classes.appResponsive}>
            <IconButton color="default" aria-label="open drawer" onClick={handleDrawerToggle}>
              <Menu fontSize="small" />
            </IconButton>
          </div>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  miniActive: PropTypes.bool.isRequired,
  sidebarMinimize: PropTypes.func.isRequired,
  handleDrawerToggle: PropTypes.func,
};

export default Header;
